module.exports = __webpack_public_path__ + "resources/icon_28_group.288bc8bc9991a8dd.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_group.png
// module id = 480
// module chunks = 0 1 2 3 4